import { MessageCircleQuestion, Camera, Scale, ArrowRight } from "lucide-react";
import { ARTICLES } from "@/data/articles";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";
import { FadeUp, SectionHeading } from "./Shared";

const ICONS = { MessageCircleQuestion, Camera, Scale };

export const Blog = () => {
    const { lang } = useLang();
    const t = STR.blog[lang];

    return (
        <section id="blog" data-testid="blog-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-5 md:px-8">
                <SectionHeading eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle} />
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    {ARTICLES.map((article, i) => {
                        const Icon = ICONS[article.icon] || MessageCircleQuestion;
                        return (
                            <FadeUp key={article.slug} delay={i * 0.1} className="h-full">
                                <a
                                    href={`/tips/${article.slug}`}
                                    data-testid={`blog-card-${article.slug}`}
                                    className="card-surface group flex h-full flex-col overflow-hidden p-0 transition-[transform,border-color] duration-300 hover:-translate-y-2 hover:border-amber-400/30"
                                >
                                    <div className="flex h-40 items-center justify-center bg-gradient-to-br from-red-600/30 via-orange-600/20 to-amber-500/20">
                                        <Icon className="h-12 w-12 text-amber-400/80 transition-transform duration-300 group-hover:scale-110" />
                                    </div>
                                    <div className="flex flex-1 flex-col p-7">
                                        <p className="text-xs text-zinc-500">
                                            {article.date} · {article.readTime[lang]}
                                        </p>
                                        <h3 className="mt-3 text-lg font-semibold leading-snug text-slate-50 transition-colors duration-200 group-hover:text-amber-300">
                                            {article.title[lang]}
                                        </h3>
                                        <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-400">
                                            {article.excerpt[lang]}
                                        </p>
                                        <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-amber-400">
                                            {t.readMore}
                                            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                                        </span>
                                    </div>
                                </a>
                            </FadeUp>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
